/**
 * Shared form input styling.
 *
 * DESIGN.md §6 "Inputs" specifies a bottom-border-only architecture on
 * `surface-container-lowest` with a `primary` focus border. Every text /
 * textarea / select / number input on the tenant console must use this
 * constant so the visual signature stays consistent (previously each
 * page re-declared its own copy and drifted over time).
 *
 * Keyboard focus adds a 2px `primary` ring with an offset coloured by
 * the parent surface — DESIGN.md §9 "Focus rings". The default constant
 * offsets against `surface-container` (the standard card background); a
 * second `INPUT_CLASS_ON_LOWEST` variant handles the rare unauthenticated
 * forms where the backdrop is the deepest void.
 */
export const INPUT_CLASS =
  'w-full rounded-lg bg-surface-container-lowest px-3 py-2 text-sm text-on-surface placeholder:text-outline border-0 border-b border-outline-variant focus:border-primary focus:outline-none transition-colors focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-surface-container disabled:opacity-60';

/**
 * Variant used for forms that render on `surface-container-lowest`
 * (e.g. Login / Register / Forgot / Reset), so the focus ring offset
 * contrasts with the page backdrop instead of vanishing into it.
 */
export const INPUT_CLASS_ON_LOWEST =
  'w-full rounded-lg bg-surface-container-lowest px-3 py-2 text-sm text-on-surface placeholder:text-outline border-0 border-b border-outline-variant focus:border-primary focus:outline-none transition-colors focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-surface-container-lowest disabled:opacity-60';

/**
 * Monospaced variant for codes / identifiers (gift card codes, API key
 * prefixes, etc.). Same focus / border chrome, differs only in font.
 */
export const INPUT_CLASS_MONO =
  'w-full rounded-lg bg-surface-container-lowest px-3 py-2 text-sm font-mono text-on-surface placeholder:text-outline border-0 border-b border-outline-variant focus:border-primary focus:outline-none transition-colors focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-surface-container disabled:opacity-60';
